import { useTranslation } from 'react-i18next'

import { DataClassName } from '@/Data/const'
import { SchemaAttributes } from '@/Data/typesV2'
import { getSchemaName } from '@/utils/dataClassMap'
import { getSchema } from '@/utils/getSchema'
import { getLocalizedSchemaAttributes } from '@/utils/schemaLocalization'

export const useActivityTypes = () => {
  const { t } = useTranslation()
  const { schema } = getSchema(getSchemaName(DataClassName.TIMERECORD))
  const attrs = getLocalizedSchemaAttributes(
    schema?.get('attributes') as SchemaAttributes,
  )
  const enumValues = attrs?.activityType?.enumValues || []

  return enumValues.map((e) => ({
    label: t(`timeTracking.activityTypes.${e.value}`) || e.title,
    value: e.value,
  }))
}
